import request from '@/utils/request'
const BASE_URL = '/Bill'

export default {
  getDefaultSerialNo(billName) {
    return request({
      url: BASE_URL + '/GetDefaultSerialNo',
      method: 'get',
      params: { billName }
    })
  },
}